module.exports = __webpack_public_path__ + "static/media/ALARM-off.0b830ba0.svg";